import Input from 'components/Input';
import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";


function AddPayScheduleModal({
    open,
    onClose
}) {

    return (
        <Modal className='add-workplace-modal' show={open} onHide={onClose} centered>
            <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
                <h4 classNam="sub-title mb-0">Add Pay Schedule</h4>
                <button
                    type="button"
                    className="close bg-transparent border-0"
                    onClick={onClose}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <Modal.Body className='pt-0'>
                <div className='border-bottom mb-4 pb-4'>
                    <div>
                        <h2 className='sub-title workplace-information-title mb-0'>General Information</h2>
                    </div>
                    <form>
                        <div className='row mt-4'>
                            <div className='col-lg-6'>
                                <label>Name*</label>
                                <Input
                                    variant='flat'
                                    fullWidth
                                    placeholder='Enter name'
                                />
                            </div>
                            <div className='col-lg-6'>
                                <label>Frequency</label>
                                <Input
                                    variant='flat'
                                    fullWidth
                                    placeholder='Enter frequency'
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div>
                    <div>
                        <h2 className='sub-title workplace-information-title mb-0'>Schedule Information</h2>
                    </div>
                    <form>
                        <div className='row mt-4'>
                            <div className='col-lg-6'>
                                <label>First Period End</label>
                                <Input
                                    type='date'
                                    variant='flat'
                                    fullWidth
                                    placeholder='dd/mm/yyyy'
                                />
                            </div>
                            <div className='col-lg-6'>
                                <label>First Pay Day</label>
                                <Input
                                    type='date'
                                    variant='flat'
                                    fullWidth
                                    placeholder='dd/mm/yyyy'
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-start mb-5'>
                <Button className='button-orange'>
                    Add Pay Schedule
                </Button>
            </Modal.Footer>
        </Modal>

    );
}


export default AddPayScheduleModal;
